// src/pages/EquityCalculatorPage.js
import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useTeamContext } from "../TeamContext";
import TopBar from "../ui/TopBar";
import FullQuestionnaire from "../questionnaire/FullQuestionnaire";
import WelcomeModal from "../ui/WelcomeModal";
import "../styles.css";

function EquityCalculatorPage() {
    const { activeWorkspaceId, getWorkspaceById, setActiveWorkspaceId, showWelcomeModal, setShowWelcomeModal } = useTeamContext();
    const [showHelpPanel, setShowHelpPanel] = useState(false);
    const [searchParams] = useSearchParams();

    // Extract workspace ID from URL query parameter
    const workspaceIdParam = searchParams.get('workspace');

    // Update activeWorkspaceId when the query param changes
    useEffect(() => {
        if (workspaceIdParam) {
            const id = parseInt(workspaceIdParam, 10);
            if (!isNaN(id)) {
                setActiveWorkspaceId(id);
            }
        }
    }, [workspaceIdParam, setActiveWorkspaceId]);

    if (!activeWorkspaceId) {
        return (
            <div className="wrapper">
                <TopBar currentTab="calculator" />
                <h2>No workspace selected</h2>
                <p>Please go to Home and open one.</p>
            </div>
        );
    }

    const ws = getWorkspaceById(activeWorkspaceId);
    if (!ws) {
        return (
            <div className="wrapper">
                <TopBar currentTab="calculator" />
                <h2>Workspace not found!</h2>
            </div>
        );
    }

    return (
        <div className="wrapper">
            {/* Floating Help Button (bottom-right) */}
            <div
                style={{
                    position: "fixed",
                    bottom: "20px",
                    right: "20px",
                    zIndex: 9999,
                }}
            >
                {showHelpPanel && (
                    <div
                        style={{
                            backgroundColor: "#FAFAFA",
                            border: "1px solid #ccc",
                            padding: "12px",
                            borderRadius: "6px",
                            marginBottom: "8px",
                            width: "200px",
                            color: "#28435a"
                        }}
                    >
                        <p><strong>Are you stuck?</strong></p>
                        <p>Want to find out if you should get more equity?</p>
                        <p>
                            <a
                                href="https://thecofoundershub.com/"
                                target="_blank"
                                rel="noreferrer"
                                style={{ color: "#f7931e", textDecoration: "underline" }}
                            >
                                Reach out to us
                            </a>
                        </p>
                    </div>
                )}
                <button
                    onClick={() => setShowHelpPanel(!showHelpPanel)}
                    style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        backgroundColor: "#28435a", /* brand "Against light" teal for info/help */
                        color: "#fff",
                        border: "none",
                        cursor: "pointer",
                        fontWeight: "bold",
                        fontSize: "18px",
                    }}
                    title="Need help?"
                >
                    ?
                </button>
            </div>
            {showWelcomeModal && <WelcomeModal onClose={() => setShowWelcomeModal(false)} />}
            <FullQuestionnaire workspace={ws} />
        </div>
    );
}

export default EquityCalculatorPage;
